import { FC } from 'react'

import { IconClock } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const ReminderNodeIcon: FC<IconProps> = ({
  boxSize,
  theme = 'turquoise'
}) => {
  return (
    <NodeIconTemplate icon={<IconClock />} theme={theme} boxSize={boxSize} />
  )
}
